export const Route = {
	route: '',
	setRoute(newRoute: string): void {
		this.route = newRoute;
	},
	getRoute(): string {
		return this.route;
	},
};
